import { render } from "./Crewmates.vue?vue&type=template&id=bc20e94a"
import script from "./Crewmates.vue?vue&type=script&lang=js"
export * from "./Crewmates.vue?vue&type=script&lang=js"
script.render = render

export default script